/**
 * Chat Image Generation - Main Container
 *
 * Layout: Sidebar (conversations) + Chat Area + Input Bar
 * Route: /v2/tools/chat-image
 */

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useChatConversations, useCreateConversation } from '@/hooks/useChatImage';
import { ConversationSidebar } from './ConversationSidebar';
import { ChatArea } from './ChatArea';

export function ChatImageGeneration() {
  useTranslation();
  const [activeId, setActiveId] = useState<string | null>(null);
  const { data: conversations, isLoading } = useChatConversations();
  const createMutation = useCreateConversation();

  const handleNew = async () => {
    const conv = await createMutation.mutateAsync({});
    setActiveId(conv.id);
  };

  return (
    <div className="flex h-[calc(100vh-8rem)] gap-0">
      <ConversationSidebar
        conversations={conversations ?? []}
        activeId={activeId}
        onSelect={setActiveId}
        onNew={handleNew}
        isLoading={isLoading}
      />
      <ChatArea
        conversationId={activeId}
        onConversationCreated={setActiveId}
      />
    </div>
  );
}
